import * as React from 'react';
import { Text as BaseText } from 'rebass/styled-components';
import { styledTheme } from '@/styledTheme';

export const Text = ({ children, ...props }) => (
  <BaseText lineHeight={['32px']} {...props}>
    {children}
  </BaseText>
);
